const BottomShape01 = () => {

    return (<div className="rmdr-bottom-shape-01" />)

}

export default BottomShape01;
